// import * as XLSX from "xlsx-js-style";
const Export = {
  // export csv
  exportCsv(data, judul) {
    const datas = data;
    const csvContent = this.convertToSCV(datas);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", judul);
    link.click();
  },
  convertToSCV(data) {
    const header = Object.keys(data[0]);
    // const header = ['Outlet', 'Date', 'Internal' , 'Descript' , 'PPN/Non PPN', 'Quantity', 'Nilai Net Sales', 'Total Pajak'];
    const rows = data.map((obj) => header.map((h) => obj[h]));
    const headerRow = header.join(",");
    const csvRows = [headerRow, ...rows.map((row) => row.join(","))];
    return csvRows.join("\n");
  },
  // export excel
  exportExcels(datas, judul) {
    import("@/services/Export2Excel").then((excel) => {
      const header = this.convertToExcel(datas);
      const field = this.convertToExcel(datas);
      const data = this.formatJsonExcel(field, datas);
      excel.export_json_to_excel({
        header: header,
        data: data,
        sheetName: `${judul}`,
        filename: `${judul}`,
        autoWidth: true,
        bookType: "xlsx",
      });
    });
  },
  convertToExcel(data) {
    const headerField = Object.keys(data[0]);
    return headerField;
  },
  formatJsonExcel(filterData, jsonData) {
    return jsonData.map((v) =>
      filterData.map((j) => {
        let value = v[j];
        return value;
      })
    );
  },
};

export default Export;
